import { IonButton, IonContent, IonFooter, IonPage, IonText } from '@ionic/react';
import { checkmarkCircleOutline } from 'ionicons/icons';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { t } from 'ttag';

import useInterval from '@hooks/useInterval';
import { formatDateMonthLong, formatTime } from '@services/date-service';
import { getLocale } from '@state/system';

import Content from './Content';
import { Icon } from './Icon';

export const TOTAL_TIME = 5;
export const INTERVAL = 1000;

const Text = styled(IonText)`
  font-weight: 400;
  font: 16px;
  margin-top: 4px;
  text-align: center;
`;

const Date = styled(IonText)`
  margin-top: 16px;
`;

const Footer = styled(IonFooter)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px 48px;
`;

const Button = styled(IonButton)`
  width: 100%;
`;

export type Props = {
  firstName: string;
  lastName: string;
  company?: string;
  position?: string;
  email: string;
  datetime: string;
  onDismiss: () => void;
};

const LeadSuccess = ({
  firstName,
  lastName,
  company,
  position,
  datetime,
  email,
  onDismiss,
}: Props) => {
  const locale = useSelector(getLocale);
  const [count, setCount] = useState(TOTAL_TIME);

  useInterval(() => {
    if (count === 1) {
      onDismiss();
    } else {
      setCount(count - 1);
    }
  }, INTERVAL);

  const date = formatDateMonthLong({ utcDate: datetime, locale });
  const time = formatTime({
    utcDate: datetime,
    locale,
    is24HourFormat: false,
  });

  return (
    <IonPage>
      <IonContent>
        <Content>
          <Icon icon={checkmarkCircleOutline} $color="--ion-color-success" />
          <h1 color="light">
            {firstName} {lastName}
          </h1>
          {company && <Text>{company}</Text>}
          {position && <Text>{position}</Text>}
          <Text>{email}</Text>
          <Date color="medium">
            {date} {time}
          </Date>
        </Content>
      </IonContent>
      <Footer className="ion-no-border">
        <p>{t`You will be redirected in ${count}...`}</p>
        <Button expand="block" fill="solid" onClick={onDismiss}>{t`Done`}</Button>
      </Footer>
    </IonPage>
  );
};

export default LeadSuccess;
